import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Popover, Modal, Form, Input, Button, Divider } from "antd";
import { toast } from "react-toastify";
import { getRequest, postRequest } from "../../../api/http";
import userServiceApi from "../../../api/userServiceApi";
import "./index.scss";
import Leftarrow from "../../../assets/images/LeftArrow.svg";
import logoutIcon from "../../../assets/images/logout-icon.svg";
import analyticsIcon from "../../../assets/images/analytics.svg";
import helpIcon from "../../../assets/images/helpIcon.svg";
import feedbackIcon from "../../../assets/images/feedback-icon.svg";
import changePwdIcon from "../../../assets/images/change-pwd-icon.svg";
import profileIcon from "../../../assets/images/profile-icon.svg";
import orgDetailsIcon from "../../../assets/images/details-icon.svg";
import manageMicrositeIcon from "../../../assets/images/ManageMicrosite.svg";
import referIcon from "../../../assets/images/Refer.svg";
import { MenuOutlined } from "@ant-design/icons";
import { clearAuthSession } from "../../../utils/authSession";

function MicroSites() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isShowProfile, setIsShowProfile] = useState(false);
  const [isOrgPending, setIsOrgPending] = useState();
  const [partnerData, setPartnerData] = useState({});
  const partnerID = localStorage.getItem("partnerID");
  const [referModal, setReferModal] = useState(false);
 const [, setCurrentCountry] = useState(null);
  const token = localStorage.getItem("token");
  const isOrgFilled = localStorage.getItem("isOrganizationProfileFilled") === "true";


  const [orgNames, setOrgNames] = useState("");
  const [formModifiedValues, setFormModifiedValues] = useState({
    type:"",
    name: "",
    image: "",
    employeesSize: "",
    address: "",
    country: "",
    categories: "",
    subCategories: "",
    companyType: "",
    companyRegistrationNumber: ""
  });

  const checkPartnerstatus = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(userServiceApi.checkPartnerstatus(token), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // optional, depends on your API
        },
      });

      // Try to parse JSON safely
      let data;
      try {
        data = await response.json();
      } catch {
        data = {};
      }
      console.log("partner status response", data);
      console.log("partner status response", response.status);
      if (response.status === 400) {
        toast.error(data?.error || "Access denied");
        const consent = document.cookie.replace(/(?:(?:^|.*;\s*)cookieConsent\s*=\s*([^;]*).*$)|^.*$/, "$1");
        if (consent === "rejected") {
          document.cookie = "cookieConsent=; max-age=0; path=/";
        }
        localStorage.clear();
        navigate(`/login/${partnerID}`, { replace: true });
        return;
      }

      if (!response.ok) {
        toast.error(data?.message || "Something went wrong");
      }

    } catch (error) {
      console.error("Error checking partner status:", error);
      toast.error("Network error. Please try again later.");
    }
  };


  useEffect(() => {
    checkPartnerstatus()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const referOrganisation = async (value) => {
    try {
      const response = await postRequest(
        userServiceApi.referOrganisation(partnerID, value.email)
      );
      if (response) {
        form.resetFields();
        toast.success("Email sent");
        setReferModal(false);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchOrganization = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await getRequest(userServiceApi.getSingleOrganization(), { headers });

      if (response && response.data) {
        setOrgNames(response.data.name);
        setIsOrgPending(response.data.isOrganizationProfilePending);
        setCurrentCountry (response?.data?.addressOutputs?.[0]?.countryOutput?.name || null);
        const resData = response.data;
        const addressOutputs = resData?.addressOutputs || [];
        const sectorsOutputs = resData?.sectorsOutputs || "";

        const formValues = {
          type: resData?.type || "",
          name: resData?.name || "",
          image: resData?.mediaLink || "",
          employeesSize: resData?.size || "",
          address: addressOutputs?.length > 0 ? addressOutputs[0]?.street : "",
          country: addressOutputs?.length > 0 ? addressOutputs[0]?.countryOutput?.name : "",
          categories: sectorsOutputs?.sectorOutput?.name ? sectorsOutputs?.sectorOutput?.name  : "",
          subCategories: sectorsOutputs?.subSectorOutput?.name ? sectorsOutputs?.subSectorOutput?.name : "",
          companyType: resData?.companyType?.value || "",
          companyRegistrationNumber: resData?.companyRegistrationNumber || ""
        };
        setFormModifiedValues(formValues);
      }
    } catch (error) {
      toast.error(error.error || "Something went wrong");
    }
  };

  useEffect(() => {
    if (token) {
      fetchOrganization();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showProfile = () => {
    setIsShowProfile(!isShowProfile);
  };

  const LogoutHandler = () => {
    navigate(clearAuthSession());
  };

  const getPartnerDetailsData = async (partnerID) => {
    try {
      const response = await getRequest(
        userServiceApi.partnerDetails(partnerID)
      );

      if (response && response.data) {
        setPartnerData(response.data);
        sessionStorage.setItem("connectedAccountId", response?.data?.connectedAccountId);
      }
    } catch (error) {
      toast.error(error.error);
    }
  };
  useEffect(() => {
    if (partnerID) {
      getPartnerDetailsData(partnerID);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isFormFilled = (values) => {
      const {
        type,
        name,
        image,
        employeesSize,
        address,
        country,
        categories,
        subCategories,
        companyType,
        companyRegistrationNumber,
      } = values;
  
      // 🔹 Common mandatory fields
      if (
        !type ||
        !name?.trim() ||
        !image || 
        !employeesSize ||
        !address?.trim() ||
        !country ||
        !categories ||
        !subCategories
      ) {
        return false;
      }
  
      // 🔹 Country specific logic
      if (country === "United Kingdom") {
        // companyType mandatory
        if (!companyType) {
          return false;
        }
  
        // If Limited Company → registration number mandatory
        if (
          companyType === "Limited Company (Ltd)" &&
          !companyRegistrationNumber?.trim()
        ) {
          return false;
        }
      }
  
      // 🔹 Other countries → no need to check companyType & registration
      return true;
    }
  
    useEffect(() => {
      const filled = isFormFilled(formModifiedValues);
      localStorage.setItem("isOrganizationProfileFilled", filled);
    }, [formModifiedValues]);

  return (
    <div className="headerBannerRow fixedRow">
      <div className="headerBannerCol">
        <div className="header-logo">
          {localStorage.getItem("page") === "personalDetails" ||
            localStorage.getItem("page") === "organisationDetails" ||
            localStorage.getItem("page") === "configurations" ? (
            <div className="back-btn-header">
              <img
                style={{ cursor: "pointer" }}
                src={Leftarrow}
                alt=""
                onClick={() => {
                  navigate(`/`);
                  localStorage.removeItem("getAllHelpState");
                }}
              />
            </div>
          ) : null}

          {localStorage.getItem("page") === "configurations" ||
            localStorage.getItem("page") === "help" ? (
            <img
              className="partner-logo"
              style={{ cursor: "pointer" }}
              src={partnerData.mediaLink}
              alt=""
              onClick={() => {
                navigate(`/`);
                localStorage.removeItem("getAllHelpState");
              }}
            />
          ) : (
            <img
              className="partner-logo"
              style={{ cursor: "pointer" }}
              src={partnerData.mediaLink}
              alt=""
              onClick={() => {
                if (isOrgPending) {
                  toast.error("Please complete updating your details");
                } else {
                  localStorage.removeItem("tab");
                  localStorage.removeItem("getAllHelpState");
                  navigate("/");
                  localStorage.setItem("page", "home");
                }
              }}
            />
          )}

          <div className="siteName-container">
            <div className="logo-holder logo-4">
              <h3>{partnerData.siteName}</h3>
            </div>
          </div>
        </div>

        <div className="org-container">
          <div className="org-text">
            <label className="org-name">{orgNames}</label>
            <label className="admin-label">Organisation Admin</label>
          </div>
          <Popover
            content={
              <div className="popover-content">
                <div className="dropdown-details">
                  <div
                    className="popover-single-content"
                    onClick={() => {
                      setIsShowProfile(false);
                      navigate("/edit-organization", {
                        state: { tab: "personalDetailsTab" },
                      });
                      localStorage.setItem("page", "personalDetails");
                    }}
                  >
                    <img src={profileIcon} alt="" />
                    <h3>Personal Details</h3>
                  </div>
                  <Divider />

                  <div
                    className="popover-single-content"
                    onClick={() => {
                      setIsShowProfile(false);
                      navigate("/edit-organization", {
                        state: { tab: "organizationDetailsTab" },
                      });
                      localStorage.setItem("page", "organisationDetails");
                    }}
                  >
                    <img src={orgDetailsIcon} alt="" />
                    <h3>Organisation Details</h3>
                  </div>
                  <Divider />

                  {!isOrgPending && (
                    <>
                      <div
                        className={`popover-single-content ${!isOrgFilled ? "disabled-banner-menus" : ""}`}
                        onClick={() => {
                          if (!isOrgFilled) return;

                          setIsShowProfile(false);
                          localStorage.setItem("page", "manageMicrosite");
                          navigate("/manageMicrosites");
                        }}
                      >
                        <img src={manageMicrositeIcon} alt="" />
                        <h3>Manage Sites</h3>
                      </div>
                      <Divider />
                    </>
                  )}

                  {!isOrgPending && (
                    <>
                      <div
                        className={`popover-single-content ${!isOrgFilled ? "disabled-banner-menus" : ""}`}
                        onClick={() => {
                          if (!isOrgFilled) return;

                          setIsShowProfile(false);
                          setReferModal(true);
                          form.resetFields();
                        }}
                      >
                        <img src={referIcon} alt="" />
                        <h3>Refer a Friend</h3>
                      </div>
                      <Divider />
                    </>
                  )}

                  {!isOrgPending && (
                    <>
                      <div
                        className={`popover-single-content ${!isOrgFilled ? "disabled-banner-menus" : ""}`}
                        onClick={() => {
                          if (!isOrgFilled) return;

                          setIsShowProfile(false);
                          localStorage.setItem("page", "changePassword");
                          navigate("/change-password");
                        }}
                      >
                        <img src={changePwdIcon} alt="" />
                        <h3>Change Password</h3>
                      </div>
                      <Divider />
                    </>
                  )}

                  <div
                    className={`popover-single-content ${!isOrgFilled ? "disabled-banner-menus" : ""}`}
                    onClick={() => {
                      if (!isOrgFilled) return;

                      setIsShowProfile(false);
                      navigate("/org-analytics");
                      localStorage.setItem("page", "analytics");
                    }}
                  >
                    <img src={analyticsIcon} alt="" />
                    <h3>Engagement (All Sites)</h3>
                  </div>
                  <Divider />

                  <div
                    className={`popover-single-content ${!isOrgFilled ? "disabled-banner-menus" : ""}`}
                    onClick={() => {
                      if (!isOrgFilled) return;

                      setIsShowProfile(false);
                      localStorage.removeItem("tab");
                      localStorage.setItem("getAllHelpState", true);
                      localStorage.setItem("page", "help");
                      navigate("/help");
                    }}
                  >
                    <img src={helpIcon} alt="" />
                    <h3>Help</h3>
                  </div>
                  <Divider />

                  <div
                    className={`popover-single-content ${!isOrgFilled ? "disabled-banner-menus" : ""}`}
                    onClick={() => {
                      if (!isOrgFilled) return;

                      setIsShowProfile(false);
                      localStorage.setItem("page", "feedback");
                      navigate("/feedback");
                    }}
                  >
                    <img src={feedbackIcon} alt="" />
                    <h3>Support & Feedback</h3>
                  </div>
                  <Divider />

                  <div
                    className="popover-single-content"
                    onClick={LogoutHandler}
                  >
                    <img src={logoutIcon} alt="" />
                    <h3>Logout</h3>{" "}
                  </div>
                </div>
              </div>
            }
            trigger="click"
            open={isShowProfile}
            onOpenChange={showProfile}
            placement="bottomRight"
          >
            <MenuOutlined
              className="org-admin-logo"
              style={{
                fontSize: "24px",
                color: "black",
                cursor: "pointer",
                backgroundColor: "#fff",
                padding: "6px",
                borderRadius: "6px",
              }}
              onClick={() => showProfile()}
            />

          </Popover>
        </div>

      </div>
      <Modal
        className="refer-modal"
        open={referModal}
        width={600}
        footer={null}
        onCancel={() => setReferModal(false)}
      >
        <div style={{ fontSize: "17px", fontWeight: "bold" }}>
          Refer organisation to a friend
        </div>
        <Form form={form} onFinish={referOrganisation} autoComplete="off">
          <div
            style={{
              marginTop: "20px",
            }}
          >
            <Form.Item
              label="Email"
              name="email"
               normalize={(value) => value?.trim()}
              rules={[
                { required: true, message: "Email is required" },
                { type: "email", message: "Enter valid email" },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                label="Cancel"
                onClick={() => setReferModal(false)}
                style={{ marginRight: "5px", marginLeft: "-10px" }}
                type="button"
                className="cancelBtn"
              >
                Cancel
              </Button>
              <Button label="Submit" className="greenBtn" htmlType="submit">
                Submit
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
export default MicroSites;
